import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, vShow as _vShow, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, withDirectives as _withDirectives, Transition as _Transition, createVNode as _createVNode, normalizeClass as _normalizeClass, Teleport as _Teleport } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "sm-modal__header"
}
const _hoisted_2 = { class: "sm-modal__header-wrap" }
const _hoisted_3 = {
  key: 0,
  class: "sm-modal__title"
}
const _hoisted_4 = { class: "sm-modal__body" }
const _hoisted_5 = {
  key: 1,
  class: "sm-modal__footer"
}
const _hoisted_6 = { class: "sm-modal__footer-wrap" }

import { useSlots, computed, ref, toRefs } from 'vue';

// Components
import SmIcon from '@/components/common/SmIcon/SmIcon.vue';
import SmButton from '@/components/common/buttons/SmButton.vue';

// Types
import { IModalProps } from '@/types/components/modal';
import { Class } from '@/types/common';

// Composables

export default /*#__PURE__*/_defineComponent({
  __name: 'SmModal',
  props: {
    isVisible: { type: Boolean, default: false },
    title: { default: '' },
    width: { default: '402px' },
    height: { default: 'auto' },
    maxWidth: { default: 'initial' },
    maxHeight: { default: '100vh' },
    isCancebleBackdrop: { type: Boolean, default: true },
    showCloseIcon: { type: Boolean, default: true },
    isLeftButton: { type: Boolean, default: true },
    isRightButton: { type: Boolean, default: true },
    leftButtonText: { default: 'Отмена' },
    rightButtonText: { default: 'Принять' },
    leftButtonType: { default: 'neutral' },
    rightButtonType: { default: 'primary' },
    isDisabledLeftButton: { type: Boolean, default: false },
    isDisabledRightButton: { type: Boolean, default: false },
    isLoadingLeftButton: { type: Boolean, default: false },
    isLoadingRightButton: { type: Boolean, default: false }
  },
  emits: ["open", "openned", "close", "closed", "leftButton", "rightButton"],
  setup(__props: any, { emit: __emit }) {

// Modules
const { header, footer }: any = useSlots();

// Props
const props = __props;

const {
  isVisible,
  title,
  width,
  height,
  maxWidth,
  maxHeight,
  isCancebleBackdrop,
  showCloseIcon,
  isLeftButton,
  isRightButton,
  leftButtonText,
  rightButtonText,
  leftButtonType,
  rightButtonType,
  isDisabledLeftButton,
  isDisabledRightButton,
  isLoadingLeftButton,
  isLoadingRightButton,
} = toRefs(props);

// Emits
const emits = __emit;

// Data
const showModalWindow = ref<boolean>(false);

// Computed
const classList = computed((): Class => ([
  { 
    'sm-modal--closable-backdrop': isCancebleBackdrop.value,
    'sm-modal--opened': isVisible.value
  }
]));

const showHeader = computed((): boolean => (
  header || title
));

const showFooter = computed((): boolean => (
  footer || isFooterButtons.value
));

const isFooterButtons = computed((): boolean => (
  isLeftButton.value || isRightButton.value
));

// Methods
const handleCloseByBackdrop = (): void => {
  if (!isCancebleBackdrop.value) return;
  
  closeModal();
};

const handleClose = (): void => {
  closeModal();
};

// Transition methods
const handleBeforeEnter = (): void => {
  emits('open');
};
const handleAfterEnter = (): void => {
  showModalWindow.value = true;
  emits('openned');
};
const handleBeforeLeave = (): void => {
  showModalWindow.value = false;
  emits('close');
};
const handleAfterLeave = (): void => {
  emits('closed');
};

const closeModal = (): void => {
  emits('close');
};

const handleClickLeftButton = (): void => {
  emits('leftButton');
};

const handleClickRightButton = (): void => {
  emits('rightButton');
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(_Transition, {
      name: "sm-modal__animation",
      onBeforeEnter: handleBeforeEnter,
      onAfterEnter: handleAfterEnter,
      onBeforeLeave: handleBeforeLeave,
      onAfterLeave: handleAfterLeave
    }, {
      default: _withCtx(() => [
        (_unref(isVisible))
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(["sm-modal", classList.value]),
              onClick: handleCloseByBackdrop
            }, [
              _createVNode(_Transition, { name: "sm-modal__animation-window" }, {
                default: _withCtx(() => [
                  _withDirectives(_createElementVNode("div", {
                    class: "sm-modal__window",
                    style: _normalizeStyle({ width: _unref(width), height: _unref(height), maxWidth: _unref(maxWidth), maxHeight: _unref(maxHeight) }),
                    onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
                  }, [
                    (showHeader.value)
                      ? (_openBlock(), _createElementBlock("header", _hoisted_1, [
                          _renderSlot(_ctx.$slots, "header", {}, () => [
                            _createElementVNode("div", _hoisted_2, [
                              _renderSlot(_ctx.$slots, "header-content", {}, () => [
                                (_unref(title))
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_unref(title)), 1))
                                  : _createCommentVNode("", true)
                              ]),
                              (_unref(showCloseIcon))
                                ? (_openBlock(), _createBlock(SmIcon, {
                                    key: 0,
                                    name: "Cancel",
                                    size: 24,
                                    class: "sm-modal__close",
                                    onClick: handleClose
                                  }))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("section", _hoisted_4, [
                      _renderSlot(_ctx.$slots, "default")
                    ]),
                    (showFooter.value)
                      ? (_openBlock(), _createElementBlock("footer", _hoisted_5, [
                          _createElementVNode("div", _hoisted_6, [
                            _renderSlot(_ctx.$slots, "footer", {}, () => [
                              (isFooterButtons.value)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    (_unref(isLeftButton))
                                      ? (_openBlock(), _createBlock(SmButton, {
                                          key: 0,
                                          type: _unref(leftButtonType),
                                          disabled: _unref(isDisabledLeftButton),
                                          loading: _unref(isLoadingLeftButton),
                                          onClick: handleClickLeftButton
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_unref(leftButtonText)), 1)
                                          ]),
                                          _: 1
                                        }, 8, ["type", "disabled", "loading"]))
                                      : _createCommentVNode("", true),
                                    (_unref(isRightButton))
                                      ? (_openBlock(), _createBlock(SmButton, {
                                          key: 1,
                                          type: _unref(rightButtonType),
                                          disabled: _unref(isDisabledRightButton),
                                          loading: _unref(isLoadingRightButton),
                                          onClick: handleClickRightButton
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_unref(rightButtonText)), 1)
                                          ]),
                                          _: 1
                                        }, 8, ["type", "disabled", "loading"]))
                                      : _createCommentVNode("", true)
                                  ], 64))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ], 4), [
                    [_vShow, showModalWindow.value]
                  ])
                ]),
                _: 3
              })
            ], 2))
          : _createCommentVNode("", true)
      ]),
      _: 3
    })
  ]))
}
}

})